import { Component, Input } from "@angular/core";
import { ValidationLevel, ValidationState } from "src/app/data-model";

@Component({
    standalone: false,
    selector: 'bp-bohrpunkt-nummer',
    templateUrl: 'bohrpunkt-nummer.component.html',
    styleUrls: ['./bohrpunkt-nummer.component.css'],
    
})
export class BohrpunktNummerComponent {
	@Input() label!: string;
	@Input() state?: ValidationState;
	
	VL = ValidationLevel;

	constructor() {	}
	
	cssClass(s?: ValidationLevel) {
		switch (s) {
		case ValidationLevel.danger: return 'danger';
		case ValidationLevel.warning: return 'warning';
		default: return '';
		}
	}
}
